import { CarouselSpot } from '~/domains/cms/promo/carousel.contests/enums';
import { ConnectedCarousel } from '~/domains/contest/domains/lobby/components/Carousel/ConnectedCarousel';

type HomeHeaderProps = {
  order: number;
};

function HomeHeader({ order }: HomeHeaderProps) {
  return (
    <div style={{ order }}>
      <ConnectedCarousel carouselSpot={CarouselSpot.HOMEHEADER} order={order} />
    </div>
  );
}

export default HomeHeader;
